import React from "react";
import isotipoHabitia from "../../../assets/isotipo.png";

// Capitulos XVI (Pagos) + XVII (Apartamentos desocupados). Render condicional por cap.
export default function PagosVaciosPage({ config, pagNum, pagTotal, capRomanoMap }) {
  const cv = config.capitulosVisibles;
  const verPag = !!cv.pagos;
  const verVac = !!cv.vacios;
  const secNum = String(pagNum - 2).padStart(2, "0");

  return (
    <section className="page">
      <div className="page-pad">
        <span className="sec-tag">{secNum} · Pagos y unidades vacías</span>
        <h2 className="big">Gastos comunes y <em>apartamentos vacíos.</em></h2>

        {verPag && (
          <div className="art">
            <div className="art-head">
              <div className="art-num">Capítulo {capRomanoMap.pagos}</div>
              <h3 className="art-title">Pago de gastos comunes</h3>
            </div>
            <p className="art-lede">
              Los gastos comunes serán abonados <b>en término</b> por propietarios e inquilinos. Es condición básica para el funcionamiento del edificio.
            </p>
            <div className="callout">
              <div className="ic">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="11" x2="12" y2="17" strokeLinecap="round" />
                  <circle cx="12" cy="7.5" r="1" fill="currentColor" />
                </svg>
              </div>
              <div>
                <p className="ttl">Impacto del pago demorado</p>
                <p className="tx">
                  Aún con recargos punitorios, los montos impagos deben ser absorbidos por los demás copropietarios, configurando una situación irregular.
                </p>
              </div>
            </div>
            <div className="callout warn">
              <div className="ic">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M12 3 22 20H2L12 3z" strokeLinejoin="round" />
                  <line x1="12" y1="10" x2="12" y2="14" strokeLinecap="round" />
                  <circle cx="12" cy="17" r="1" fill="currentColor" />
                </svg>
              </div>
              <div>
                <p className="ttl">Inhabilitación de servicios</p>
                <p className="tx">
                  El no pago <b>inhabilita reserva y uso de servicios</b> (barbacoa, gimnasio, piscina, sauna, hidromasaje). Pagos vencidos: sanciones legales correspondientes.
                </p>
              </div>
            </div>
          </div>
        )}

        {verVac && (
          <div className="art">
            <div className="art-head">
              <div className="art-num">Capítulo {capRomanoMap.vacios}</div>
              <h3 className="art-title">Apartamentos desocupados por tiempo prolongado</h3>
            </div>
            <p className="art-lede">Recomendaciones ante períodos prolongados de desocupación:</p>
            <ol className="rules">
              <li><span className="m">·</span><span>Corte de electricidad.</span></li>
              <li><span className="m">·</span><span>Cierre del gas.</span></li>
              <li><span className="m">·</span><span>Cierre de válvulas de calefacción y de todas las aberturas.</span></li>
              <li><span className="m">·</span><span>Inspección de canillas y descargas de agua.</span></li>
            </ol>
          </div>
        )}
      </div>
      <div className="pfooter">
        <div className="br"><img src={isotipoHabitia} alt="" />habitia · Reglamento Interno</div>
        <div className="pn">{String(pagNum).padStart(2, "0")} / {String(pagTotal).padStart(2, "0")}</div>
      </div>
    </section>
  );
}
